import React from 'react';
import { N300 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
var ResultMetaWrapper = styled.span({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: "var(--ds-text-subtle, ".concat(N300, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var SpacerWrapper = styled.span({
  color: "var(--ds-text-subtle, ".concat(N300, ")"),
  margin: "0px ".concat("var(--ds-space-100, 8px)")
});
export function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
export var QuickFindResultMeta = function QuickFindResultMeta(_ref) {
  var meta = _ref.meta;
  return /*#__PURE__*/React.createElement(ResultMetaWrapper, null, meta.filter(function (metaItem) {
    return metaItem !== null && metaItem !== undefined;
  }).map(function (metaItem, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, metaItem, index !== meta.length - 1 && /*#__PURE__*/React.createElement(SpacerWrapper, null, "\u2022"));
  }));
};